/** Reserved category: this group also enforces server-side access control. */
export const TEST_GAME_GROUP = '测试游戏';
export function canSeeTestGames(user?: {role?: unknown; beta_user?: unknown; internalUser?: unknown} | null) {
  return !!user && (user.role === 'admin' || user.role === 'superadmin' || !!user.beta_user || !!user.internalUser);
}
export function isTestGame(game: {categories?: unknown}) {
  const categories = typeof game.categories === 'string' ? JSON.parse(game.categories) : game.categories;
  return Array.isArray(categories) && categories.includes(TEST_GAME_GROUP);
}
